"use strict";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

exports.__esModule = true;
exports.persistQueryClient = persistQueryClient;
exports.persistQueryClientRestore = persistQueryClientRestore;
exports.persistQueryClientSave = persistQueryClientSave;
exports.persistQueryClientSubscribe = persistQueryClientSubscribe;

var _core = require("../core");
/**
 * Restores persisted data to the QueryCache
 *  - data obtained from persister.restoreClient
 *  - data is hydrated using hydrateOptions
 * If data is expired, busted, empty, or throws, it runs persister.removeClient
 */


function persistQueryClientRestore(_x) {
  return _persistQueryClientRestore.apply(this, arguments);
}
/**
 * Persists data from the QueryCache
 *  - data dehydrated using dehydrateOptions
 *  - data is persisted using persister.persistClient
 */


function _persistQueryClientRestore() {
  _persistQueryClientRestore = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
    var queryClient, persister, _ref$maxAge, maxAge, _ref$buster, buster, hydrateOptions, persistedClient, expired, busted;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            queryClient = _ref.queryClient, persister = _ref.persister, _ref$maxAge = _ref.maxAge, maxAge = _ref$maxAge === void 0 ? 1000 * 60 * 60 * 24 : _ref$maxAge, _ref$buster = _ref.buster, buster = _ref$buster === void 0 ? '' : _ref$buster, hydrateOptions = _ref.hydrateOptions;
            _context.prev = 1;
            _context.next = 4;
            return persister.restoreClient();

          case 4:
            persistedClient = _context.sent;

            if (persistedClient) {
              if (persistedClient.timestamp) {
                expired = Date.now() - persistedClient.timestamp > maxAge;
                busted = persistedClient.buster !== buster;

                if (expired || busted) {
                  persister.removeClient();
                } else {
                  (0, _core.hydrate)(queryClient, persistedClient.clientState, hydrateOptions);
                }
              } else {
                persister.removeClient();
              }
            }

            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);

            if (process.env.NODE_ENV !== 'production') {
              queryClient.getLogger().error(_context.t0);
              queryClient.getLogger().warn('Encountered an error attempting to restore client cache from persisted location. As a precaution, the persisted cache will be discarded.');
            }

            persister.removeClient();

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
  return _persistQueryClientRestore.apply(this, arguments);
}

function persistQueryClientSave(_x2) {
  return _persistQueryClientSave.apply(this, arguments);
}
/**
 * Subscribe to QueryCache and MutationCache updates (for persisting)
 * @returns an unsubscribe function (to discontinue monitoring)
 */


function _persistQueryClientSave() {
  _persistQueryClientSave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
    var queryClient, persister, _ref2$buster, buster, dehydrateOptions, persistClient;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            queryClient = _ref2.queryClient, persister = _ref2.persister, _ref2$buster = _ref2.buster, buster = _ref2$buster === void 0 ? '' : _ref2$buster, dehydrateOptions = _ref2.dehydrateOptions;
            persistClient = {
              buster: buster,
              timestamp: Date.now(),
              clientState: (0, _core.dehydrate)(queryClient, dehydrateOptions)
            };
            _context2.next = 4;
            return persister.persistClient(persistClient);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _persistQueryClientSave.apply(this, arguments);
}

function persistQueryClientSubscribe(props) {
  var unsubscribeQueryCache = props.queryClient.getQueryCache().subscribe(function () {
    persistQueryClientSave(props);
  });
  var unusbscribeMutationCache = props.queryClient.getMutationCache().subscribe(function () {
    persistQueryClientSave(props);
  });
  return function () {
    unsubscribeQueryCache();
    unusbscribeMutationCache();
  };
}
/**
 * Restores persisted data to QueryCache and persists further changes.
 */


function persistQueryClient(props) {
  var hasUnsubscribed = false;
  var persistQueryClientUnsubscribe;

  var unsubscribe = function unsubscribe() {
    hasUnsubscribed = true;
    persistQueryClientUnsubscribe == null ? void 0 : persistQueryClientUnsubscribe();
  }; // Attempt restore


  var restorePromise = persistQueryClientRestore(props).then(function () {
    if (!hasUnsubscribed) {
      // Subscribe to changes in the query cache to trigger the save
      persistQueryClientUnsubscribe = persistQueryClientSubscribe(props);
    }
  });
  return [unsubscribe, restorePromise];
}